import React, {useEffect, useState} from 'react';
import { Button, Dialog, Grid, Box } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import styles from '../ConfirmDeletionModal/styles.module.scss';
import '../ConfirmDeletionModal/styles.module.scss';
import { isFunc } from '@utils/functions';
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";


const ConfirmActionModal = ({ open, setOpen, title, content, yesLabel, noLabel, parameters, hideNoButton = false, crestJustClosing = false }) => {
  const dimensions = useSelector(state => state.dimensions);
  const [isAlreadyClicked, setIsAlreadyClicked] = useState(false);

  useEffect(() => {
    if (open) setIsAlreadyClicked(false);
  }, [open]);//eslint-disable-line

  return (
    <>
      <Dialog open={open} className={'ConfirmDeletionDialog'} onClose={() => {}} fullScreen={dimensions.isScreenLessSM} data-testid="dialog-confirm-action">
        <MuiDialogTitle>
          <Box className={`${styles.modalTitle} ${dimensions.isScreenLessMD ? styles.mobile : ''}`}>{parameters?.title ?? title}</Box>
          <IconButton aria-label="close" className={styles.modalCloseButton} onClick={() => setOpen(false)} data-testid="button-confirm-action-close">
            <CloseRoundedIcon />
          </IconButton>
        </MuiDialogTitle>
        <MuiDialogContent>
          <Box className={styles.text}>
            {!!content && (<p>{content}</p>)}
            {(!content && !!parameters?.content) && (<>{parameters?.content}</>)}
          </Box>
        </MuiDialogContent>
        <MuiDialogActions>
          <Grid container justifyContent="space-between">
            {!!hideNoButton ? (
              <Grid item />
            ) : (
              <Button
                className={`${styles.actionButton} ${styles.secondary}`}
                data-testid="button-confirm-action-no"
                onClick={() => {
                  if (isFunc(parameters?.noAction) && !isAlreadyClicked) {
                    setIsAlreadyClicked(true);
                    parameters.noAction();
                  }
                  setOpen(false);
                }}
                color="secondary"
                variant="outlined"
                type="button"
                disableElevation
              >
                {noLabel ?? 'NO'}
              </Button>
            )}
            <Button
              className={`${styles.actionButton}`}
              data-testid="button-confirm-action-yes"
              type="button"
              variant="contained"
              color="primary"
              onClick={() => {
                if (isFunc(parameters?.yesAction) && !isAlreadyClicked) {
                  setIsAlreadyClicked(true);
                  parameters.yesAction();
                }
                setOpen(false);
              }}
            >
              {yesLabel ?? 'YES'}
            </Button>
          </Grid>
        </MuiDialogActions>
      </Dialog>
    </>
  );
};

ConfirmActionModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  yesLabel: PropTypes.string,
  noLabel: PropTypes.string,
  parameters: PropTypes.object,
  hideNoButton: PropTypes.bool
};

export default ConfirmActionModal;

